const isProduction = location.hostname === 'go.winerist.com';
const isStaging = location.hostname === 'st-go.winerist.com';

export const environment = {
  isProduction,
  isStaging,
  host: '/api/v1',
  stripeKey: isProduction ? 'pk_live_4Vfpf3NZuOHzselpTPoUwDuX' : 'pk_test_4VfpAs6nmqYGwhoAwmt3gGJt',
  paynet: {
    host: isProduction ? 'https://paynet.md/acquiring/getecom' : 'https://test.paynet.md/acquiring/getecom',
  },
};
